function renderGrid(priceChanges) {
    const grid = document.getElementById('price-changes-grid');
    const supplierFilterInput = document.getElementById('supplier-filter');
    const filterValue = supplierFilterInput.value.trim().toLowerCase();
    const sortBySelect = document.getElementById('sort-by');
    const sortValue = sortBySelect.value;

    grid.innerHTML = '';

    let filteredItems = priceChanges.filter(item => {
        return item.supplier_name.toLowerCase().includes(filterValue);
    });

    if (sortValue === 'supplier-ascending') {
        filteredItems.sort((a, b) => a.supplier_name.localeCompare(b.supplier_name));
    } else if (sortValue === 'supplier-descending') {
        filteredItems.sort((a, b) => b.supplier_name.localeCompare(a.supplier_name));
    } else if (sortValue === 'date-ascending') {
        filteredItems.sort((a, b) => new Date(a.effective_date) - new Date(b.effective_date));
    } else if (sortValue === 'date-descending') {
        filteredItems.sort((a, b) => new Date(b.effective_date) - new Date(a.effective_date));
    } else if (sortValue === 'percent-ascending') {
        filteredItems.sort((a, b) => a.change_percent - b.change_percent);
    } else if (sortValue === 'percent-descending') {
        filteredItems.sort((a, b) => b.change_percent - a.change_percent);
    }

    filteredItems.forEach((item) => {
        let gridItem = document.createElement('div');
        gridItem.classList.add('price__changes-wrapper', 'price__changes-item');

        let products = [];
        if (item.products && Array.isArray(item.products)) {
            products = item.products;
        }

        let productListHTML = '';
        if (products.length > 0) {
            productListHTML = '<div class="price__changes-item_products">';
            products.forEach(product => {
                if (typeof product === 'string' && product) {
                    productListHTML += `<p>- ${product.trim()}</p>`;
                }
            });
            productListHTML += '</div>';
        }

        let imageTag = '';
        if (window.priceChangeImages[item.supplier_name]) {
            const imageUrl = window.priceChangeImages[item.supplier_name];
            const altText = item.supplier_name ? `${item.supplier_name} Logo` : 'Logo';
            imageTag = `<img class="price__changes-item_logo" src="${imageUrl}" alt="${altText}">`;
        } else {
            imageTag = `<span class="price__changes-item_logo">${item.supplier_name}</span>`;
        }

        gridItem.innerHTML = `
            ${imageTag}
            <p class="price__changes-item_supplier">${item.supplier_name}</p>
            ${productListHTML}
            <p class="price__changes-item_date">${new Date(item.effective_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
            <p class="price__changes-item_percent">${item.change_percent}%</p>
        `;

        grid.appendChild(gridItem);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const sortBySelect = document.getElementById('sort-by');
  const supplierFilterInput = document.getElementById('supplier-filter');
  const clearFilterButton = document.getElementById('clear-filter');

  window.priceChanges.sort((a, b) => new Date(b.effective_date) - new Date(a.effective_date));

  renderGrid(window.priceChanges);

  sortBySelect.addEventListener('change', () => {
    renderGrid(window.priceChanges);
  });

  supplierFilterInput.addEventListener('input', () => {
    renderGrid(window.priceChanges);
  });

  clearFilterButton.addEventListener('click', () => {
    supplierFilterInput.value = '';
    renderGrid(window.priceChanges);
  });
});